import { render, staticRenderFns } from "./DepartmentFixedPhraseSelector.vue?vue&type=template&id=574727e3&scoped=true&"
import script from "./DepartmentFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./DepartmentFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentFixedPhraseSelector.vue?vue&type=style&index=0&id=574727e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574727e3",
  null
  
)

export default component.exports